export enum launchMethod {
	native,
	browserExtension,
	html5,
	icaFile,
	protocolHandler,
}

export enum platform {
	ios,
	ipadOS,
	android,
	androidTablet,
	windows,
	mac,
	linux,
	windowsMobile,
	chromeOS,
	nativeWidget,
	other,
}

export const platformString = {
	[platform.ios]: 'iOS',
	[platform.ipadOS]: 'iPadOS',
	[platform.android]: 'Android',
	[platform.androidTablet]: 'Android Tablet',
	[platform.windows]: 'Windows',
	[platform.mac]: 'Mac',
	[platform.linux]: 'Linux',
	[platform.windowsMobile]: 'Windows Mobile',
	[platform.chromeOS]: 'ChromeOS',
	[platform.nativeWidget]: 'Native Widget',
	[platform.other]: 'Other',
};
